/*=========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
    isUserLoggedIn: () => {
        let isAuthenticated = false;

        if (localStorage.getItem('userToken')) isAuthenticated = true;
        else isAuthenticated = false

        return isAuthenticated;
    },
}